const ToggleButton = ({ label, checked, onChange, readOnly = false }) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        className="sr-only peer"
        onChange={readOnly ? null : onChange}
      />
      <div className="relative w-8 h-4 bg-gray peer-focus:outline-none peer-focus:ring-5 peer-focus:ring-transparent dark:peer-focus:ring-gray-dirty_back rounded-full peer dark:bg-gray peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[3.5px] after:bg-white after:border-gray after:border after:rounded-full after:h-3 after:w-3 after:transition-all dark:border-gray peer-checked:bg-blue"></div>
      {label && (
        <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
          {label}
        </span>
      )}
    </label>
  );
};

export default ToggleButton;
